const Overlay = () => (
	<div className=' fixed h-screen w-screen z-20 top-0 left-0 bg-gray-500 bg-opacity-20' />
)
export default Overlay
